'use strict';

var ChartSponsorForecastViewport = function ChartSponsorForecastViewport(ChartViewport, chartGroups, chartSimpleBars, chartXAxis) {
  var chartParams = require('./ParamsViewport');
  var chartScales = require('./Scales');
  var Chart = function Chart(container, formatters) {
    var groups = chartGroups('d1');
    var simpleBars = chartSimpleBars('m1');
    var xAxis = chartXAxis(formatters.xAxisTickFormatter, formatters.xAxisTickValues);
    ChartViewport.call(this, container, chartParams, chartScales, groups, simpleBars, xAxis);
  };
  Chart.prototype = Object.create(ChartViewport.prototype);
  Chart.constructor = Chart;
  return Chart;
};
ChartSponsorForecastViewport.$inject = ['ChartViewport', 'ChartElementsGroup', 'ChartElementsSimpleBars', 'ChartElementsXAxis'];
module.exports = ChartSponsorForecastViewport;